export const NC_VIEW = "VIEW_NOTIFICATION";
export const APP_LOADER = "APP_ROOT_LOADER";
export const GET_DEVICE_HEIGHT = "Get_Update_Device_Height";
export const UPDATE_ROOT_STATE = "update_redux_state";

// Auth Constants
export const SET_REGISTER_USER = "SET_REGISTER_USER";
export const SET_USER_INFO = "set_login_user_infomation";
export const SET_LOGIN_USER = "[auth] set login user data"
export const USER_LOGOUT = "[auth] change user login flag"
export const VILLAGE_BATTLE_RANK = "[auth] WcnVillageRank.getTopRank"

export const SET_STRENTH = "set_user_family_team_strength";
export const JOIN_FAMILY = "join_invite_family";
export const UPDATE_AUTH_STATE = "update_auth_root_state";

// Chat Constants
export const UPDATE_CHAT_STATE = "update_chat_root_state";
export const NEW_CONVERSATION_LIST = "[CHAT] MEMBER AND TEAM LIST"
export const CONVERSATION_LIST = "[CHAT] GROUP LIST WITH LAST MESSAGE"
export const GROUP_MESSAGES_TARGET = "[CHAT] CHAT ROOM GROUP ID";
export const GROUP_MESSAGES = "[CHAT] SET GROUP MESSAGES";

export const IS_SOCKET_LOGIN = "[CHAT] SOCKET CONNECTION LOGIN";
export const IS_SOCKET_LOGOUT = "[CHAT] SOCKET CONNECTION LOGOUT";

export const IS_SOCKET_CONNECTING = "[CHAT] SOCKET CONNECTING";
export const IS_SOCKET_CONNECTED = "[CHAT] SOCKET CONNECTED";
export const IS_SOCKET_DIE = "[CHAT] SOCKET DIE";


// NOTIFICATION
export const SEND_BROWSER_NOTIFICATION = "[notification] send browser notification";
export const BROWSER_FOCUSE_STATUS = "[notification] browser tab focuse status";

// STATISTICS
export const STATISTICS_TAB_CHANGE = "[STATISTICS] handle tab change";
export const STATISTICS_USERS_LIST = "[STATISTICS] get user list";
export const STATISTICS_SET_USER_INFO = "[STATISTICS] set selected user";
export const ACTIVITIES_LOGS_VIDEOS = "[STATISTICS] ACTIVITIES VIDEOS LIST";
export const ACTIVITIES_LOGS_QUESTIONS = "[STATISTICS] ACTIVITIES QUESTIONS LIST";
export const ACTIVITIES_LOGS_QUESTIONS_EMPTY = "[STATISTICS] ACTIVITIES QUESTIONS LIST EMPTY";
export const ACTIVITIES_LOGS_INDEX = "[STATISTICS] ACTIVITIES TAB INDEX";
export const ACTIVITIES_TIME_PROGRESS = "[STATISTICS] ACTIVITIES TIME PROGRESS";


// Settings
export const INITIALIZE_SETTINGS = "RESET SETTINGS REDUCER STATE";
export const WELCOME_VIDEO_URL = "WELCOME SCREEN VIDEO";
export const IS_REMEMBER_ME = "BROWSER USER SESSION REMEMBER";

export const IS_USER_ONLINE = "USER IS ONLINE";
export const IS_USER_OFFLINE = "USER IS OFFLINE";
export const IS_WINDOW_RESIZE = "BROWSER WINDOW RESIZE HIGHT";

export const close_notification = "close snackmessage notification";
export const open_notification = "open snackmessage notification";
export const IS_ENGLISH_ENABLE = "IS ENGLISH ENABLE";
export const IS_ENGLISH_DISABLE = "IS ENGLISH DISABLE";

// FAMILY
export const USER_TEAMS = "WcnFamily.getUserOrganization";

// INVITE
export const INVITE_E_TOKEN = "WoogiConnectInvite.getTokenForSendingEmail";
export const INVITE_MESSAGE_TEMPLATE = "WoogiConnectInvite.getMessageTemplate";


// Root Dialog
export const LOADING_DIALOG_TRUE = "root loading dialog visible";
export const LOADING_DIALOG_FALSE = "root loading dialog hide";

export const RECORD_EXCEPTION_TRUE = "recording exception dialog true";
export const RECORD_EXCEPTION_FALSE = "recording exception dialog hide";

// Main
export const GET_DAILY_TASK = "GET DAILY TASK";
export const GET_DAILY_RIDDLE = "GET DAILY RIDDLE";
export const GET_MEMBERS_PROGRESS = "GET MEMBERS PROGRESS";
export const APP_LANGUAGE = "APP LANGUAGE";